import { create } from 'domain';
import '../../styles/Dropdown.css';
import { Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';

interface ItemList {
  value: number;
  label: string;
}

interface BasePulldownProps {
  itemList: ItemList[];
  selectedItem: number;
  defaultLabel: string;
  onChange: (item: number) => void;
}

const BasePulldown = ({
  itemList,
  selectedItem,
  onChange,
  defaultLabel,
}: BasePulldownProps) => {
  return (
    <Dropdown className="base-dropdown">
      <Dropdown.Toggle variant="light" className="base-dropdown-toggle">
        {itemList.find((item) => item.value === selectedItem)?.label ??
          defaultLabel}
      </Dropdown.Toggle>
      {createPortal(
        <Dropdown.Menu className="base-dropdown-menu">
          {itemList.map((item) => (
            <Dropdown.Item
              key={item.value}
              onClick={() => onChange(item.value)}
              className="base-dropdown-item"
            >
              {item.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>,
        document.body
      )}
    </Dropdown>
  );
};

export default BasePulldown;
